import Info from '@ui/components/Info';
import { TokenIcon } from '@ui/components/TokenIcon';
import { COIN_MODE } from '@ui/hooks/useCoinMode';
import useNftTokens from '@ui/hooks/useNftTokens';
import { useTranslations } from '@ui/i18n';
import { formatTokenAmount } from '@ui/utils/format';

const NftPanel = () => {
  const t = useTranslations();
  const croNftTokens = useNftTokens({
    coinMode: 'cro',
  });
  const atomNftTokens = useNftTokens({
    coinMode: 'atom',
  });

  return (
    <>
      <Info
        title={t('Claimable {coin}', {
          coin: 'CRO',
        })}
        value={
          formatTokenAmount(croNftTokens.redeemableTokenAmount) ?? undefined
        }
        icon={(props) => <TokenIcon token="cro" {...props} />}
      />
      <Info
        title={t('Claimable {coin}', {
          coin: 'ATOM',
        })}
        value={
          formatTokenAmount(
            atomNftTokens.redeemableTokenAmount,
            undefined,
            COIN_MODE.atom.decimals,
          ) ?? undefined
        }
        icon={(props) => <TokenIcon token="atom" {...props} />}
      />
    </>
  );
};

export default NftPanel;
